export function shouldAutoCloseAuthModal(mode = 'login') {
  return mode === 'login';
}
